// Función para poder manejar errores al usar async/wait para peticiones al API.
export default function to(promise) {
    return promise.then(response => {
    return   [null, response.data];
    })
    .catch(err => [err]);
}